module.exports = __webpack_public_path__ + "img/aleo.c5e83844.png";